module.exports = __webpack_public_path__ + "static/media/ic_undo.a07bf20d.svg";